import { ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { DescriptionData, DescriptionService } from './description.service';

@Injectable()
export class DescriptionResolver {
  constructor(private descriptionService: DescriptionService) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(route: ActivatedRouteSnapshot): Observable<DescriptionData | null> {
    return this.descriptionService.getDescription();
  }
}
